import { SearchLayout } from "@search/app/layout";
import { SearchContext } from "@search/context/SearchContext";
import { createSearchStore } from "@search/store/searchStore";
import React from "react";
import { useRef } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "vite/modulepreload-polyfill";

import "./main.css";

/* eslint-disable react-refresh/only-export-components */
const App = () => {
  const store = useRef(createSearchStore(document.location.search)).current;

  return (
    <SearchContext.Provider value={store}>
      <SearchLayout />
    </SearchContext.Provider>
  );
};
/* eslint-enable react-refresh/only-export-components */
ReactDOM.createRoot(document.querySelector("main")!).render(
  <React.StrictMode>
    <React.Suspense>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Suspense>
  </React.StrictMode>,
);
